<script>
    import truncate from 'lodash/truncate';

    export let text = '';
    export let max = 100;

    let collapsed = true;
    $: needTruncate = text.length > max;
    $: textToShow = needTruncate && collapsed ? truncate(text, {length: max, omission: ' ...'}) : text;
</script>

{#if text}
    <p class="mb-0">
        {textToShow}
    </p>
    {#if needTruncate}
        <a on:click={() => collapsed = !collapsed} class="btn link-red collapsed"
           data-toggle="collapse"
           href="javascript:void(0)"
           role="button"
           aria-expanded="false"
           aria-controls="collapseText">leggi tutto</a>
    {/if}
{/if}
